import { useCallback } from "react";

import { useUpdateUser } from "@/shared/hooks/useUpdateUser";
import { buildAddress } from "@/shared/utils/addressUtils";

export function useSaveUserFields() {
  const { updateUserAsync } = useUpdateUser();

  return useCallback(
    async (data: Record<string, string>) => {
      if (data.forward_address) {
        const address = buildAddress({
          streetAddress: data.forward_address,
          apartment: data.forward_apartment || "",
          city: data.forward_city || "",
          state: data.forward_state || "",
          zipCode: data.forward_zip || "",
        });
        await updateUserAsync({ user: { address } });
      }

      const userUpdate: Record<string, unknown> = {};
      if (data.user_dob) userUpdate.date_of_birth = data.user_dob;
      if (Object.keys(userUpdate).length > 0) {
        await updateUserAsync({ user: userUpdate });
      }
    },
    [updateUserAsync],
  );
}
